import {Button, Popconfirm, Row, Space, Tooltip} from "antd";
import React from "react";
import Icon from "assets/icons";
import {ReactComponent as RecycleIconSVG} from "assets/images/svg/recycle.svg";
import {ReactComponent as PrinterIconSVG} from "assets/images/svg/printer.svg";
import {ReactComponent as PenIconSVG} from "assets/images/svg/pen.svg";
import {ReactComponent as EyeIconSVG} from "assets/images/svg/eye.svg";
import {ChangePassSVG, ExcelSVG, SaveIconSVG} from "assets";
import {ReportSVG} from "assets";
import {StopOutlined, SyncOutlined} from "@ant-design/icons";

type Props = {
  addFunction?: any;
  deleteFunction?: any;
  printFunction?: any;
  editFunction?: any;
  showDetailFunction?: any;
  saveFunction?: any;
  reportFunction?: any;
  updateFunction?: any;
  disableFunction?: any;
  children?: any;
  toolTipSave?: any;
  toolTip?: any;
  disabled?: any;
  titlePopupConfirm?: string;
};

const ListActionButton: React.FC<Props> = ({
  addFunction,
  deleteFunction,
  printFunction,
  editFunction,
  showDetailFunction,
  saveFunction,
  reportFunction,
  updateFunction,
  disableFunction,
  children,
  toolTipSave,
  toolTip = {},
  disabled = {},
  titlePopupConfirm = "Bạn muốn xóa?",
}) => {
  return (
    <Space style={{}} size="small">
      {addFunction !== undefined ? (
        <Button
          style={{position: "relative", bottom: "4px"}}
          type="text"
          onClick={addFunction}
          icon={<Icon.add></Icon.add>}
          disabled={disabled.addFunction}
        ></Button>
      ) : (
        <></>
      )}
      {printFunction !== undefined ? (
        <Button
          onClick={printFunction}
          type="text"
          icon={<PrinterIconSVG />}
          disabled={disabled.printFunction}
        />
      ) : (
        <></>
      )}
      {editFunction !== undefined ? (
        <Button
          disabled={disabled.editFunction}
          onClick={editFunction}
          type="text"
          icon={<PenIconSVG />}
        />
      ) : (
        <></>
      )}
      {showDetailFunction !== undefined ? (
        <Button
          onClick={showDetailFunction}
          type="text"
          icon={<EyeIconSVG />}
          disabled={disabled.showDetailFunction}
        />
      ) : (
        <></>
      )}
      {deleteFunction !== undefined ? (
        <Popconfirm
          className="danger-confirm"
          title={titlePopupConfirm}
          onConfirm={deleteFunction}
          disabled={disabled.deleteFunction}
        >
          <Button type="text" icon={<RecycleIconSVG />} />
        </Popconfirm>
      ) : (
        <></>
      )}
      {saveFunction !== undefined ? (
        <Tooltip title={toolTipSave}>
          <Button
            type="text"
            onClick={saveFunction}
            icon={<SaveIconSVG></SaveIconSVG>}
            disabled={disabled.saveFunction}
          ></Button>
        </Tooltip>
      ) : (
        <></>
      )}
      {updateFunction !== undefined ? (
        <Tooltip title={toolTipSave}>
          <Button
            type="text"
            onClick={updateFunction}
            icon={<ChangePassSVG></ChangePassSVG>}
            disabled={disabled.updateFunction}
          ></Button>
        </Tooltip>
      ) : (
        <></>
      )}
      {reportFunction !== undefined ? (
        <Button
          type="text"
          onClick={reportFunction}
          icon={<ExcelSVG></ExcelSVG>}
          disabled={disabled.reportFunction}
        ></Button>
      ) : (
        <></>
      )}
      {disableFunction !== undefined ? (
        <Tooltip title={toolTip.disableFunction}>
          <Button
            type="text"
            onClick={disableFunction}
            icon={<StopOutlined></StopOutlined>}
            disabled={disabled.reportFunction}
          ></Button>
        </Tooltip>
      ) : (
        <></>
      )}
      {children}
    </Space>
  );
};

export default ListActionButton;
